// Combina registros existentes; não reconstrói alterações sem trilha de auditoria.
export function buildTaskHistory(task, transitions = []) {
  const events = transitions.map(event => ({
    id: `stage:${event.id}`, kind: 'stage', at: event.occurred_at,
    actorId: event.moved_by || null, title: 'Etapa atualizada',
    detail: `${event.from_nome || (event.from_stage_id ? 'Etapa indisponível' : 'Sem etapa')} → ${event.to_nome || (event.to_stage_id ? 'Etapa indisponível' : 'Sem etapa')}`,
  }))
  if (task.created_at) events.push({ id: 'created', kind: 'created', at: task.created_at, actorId: task.created_by || null, title: 'Tarefa criada' })
  // concluido_at só descreve a conclusão atual; reaberturas anteriores não são inferidas.
  if (task.status === 'concluido' && task.concluido_at) events.push({ id: 'completed', kind: 'completed', at: task.concluido_at, actorId: null, title: 'Tarefa concluída', detail: 'Data da conclusão atual.' })
  return events.filter(event => event.at && Number.isFinite(new Date(event.at).getTime()))
    .sort((a, b) => new Date(b.at) - new Date(a.at) || a.id.localeCompare(b.id))
}
